<script>
    // import Modal from "carbon-components-svelte";
    import { Modal } from "carbon-components-svelte";
    let modal_now,
        modalTitle,
        modalMessage,
        open = false;
    const modal = (type, title, message) => {
        modal_now = type;
        modalTitle = title;
        modalMessage = message;
        open = true; // open modal message to user
    };
    export function modalLampshade() {
        modal(
            "lampshade",
            "Lampshade model",
            "This model can generate gcode with filesize >10 MB - click the button below to access the model on Google Colab and generate gcode (zero-install zero-coding!)"
        );
    }
</script>

{#if modal_now == "lampshade"}
    <Modal
        primaryButtonText="Colab model"
        on:submit={() =>
            window.open(
                "https://colab.research.google.com/gist/fullcontrol-xyz/589c78de0093698a07ec724af6428f09/fullcontrol-lampshade.ipynb",
                "_blank"
            )}
        bind:open
        modalHeading={modalTitle}
        on:open
        on:close
    >
        <p>
            {modalMessage}
        </p>
    </Modal>
{/if}
